// src/hooks/useSnapScroller.js
import { useRef, useState } from 'react';

/**
 * Tracks which slide is in view for a horizontally scroll-snapping strip,
 * and scrolls to a given slide on demand.
 *
 * Assumes each slide is exactly one scroller-width wide.
 */
const useSnapScroller = (slideCount) => {
  const scrollerRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);

  const handleScroll = () => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    const index = Math.round(scroller.scrollLeft / scroller.clientWidth);
    setActiveSlide(Math.min(Math.max(index, 0), slideCount - 1));
  };

  const scrollToSlide = (index) => {
    const scroller = scrollerRef.current;
    if (!scroller) return;
    scroller.scrollTo({ left: index * scroller.clientWidth, behavior: 'smooth' });
  };

  return { scrollerRef, activeSlide, handleScroll, scrollToSlide };
};

export default useSnapScroller;
